<template lang="html">

    <section class="section-links flex wrap">
  
      <article class="col-50 pad-sec" v-for="(e,key) in data">
        <a :href="$t('enlaces.' + e)"></a>
        <div class="container-text">
          <h2 class="title title-36" v-html="$t(`otras_secciones['${e}'].titulo`)"></h2>
          <p v-html="$t(`otras_secciones['${e}'].texto`)"></p>
          <p class="go"><span v-html="$t(`otras_secciones['${e}'].boton_texto`)"></span><i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></p>
        </div>
      </article>

    </section>

</template>

<script lang="js">
  export default  {
    name: 'acceso-a-secciones',
    props: ['data'],
}
</script>


// WEBPACK FOOTER //
// src/components/parts/acceso-a-secciones.vue